import { render, staticRenderFns } from "./imgF.vue?vue&type=template&id=368de30d"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368de30d')) {
      api.createRecord('368de30d', component.options)
    } else {
      api.reload('368de30d', component.options)
    }
    module.hot.accept("./imgF.vue?vue&type=template&id=368de30d", function () {
      api.rerender('368de30d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgF.vue"
export default component.exports